<template>
  <div class="pageSearchReleaseOrder">
    <h2>{{ $t("pages.wording.searchReleaseOrder") }}</h2>
    <el-form label-width="150px">
      <h3>{{ $t("pages.wording.searchCondition") }}</h3>
      <!--查詢條件-->
      <div class="boxContain c-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--預約單-->
              <el-input
                v-model.trim="queryItems.reserveNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.releaseNo')"
              ><!--放行單-->
              <el-input
                v-model.trim="queryItems.releaseOrderNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendor')"
              ><!--公司名稱-->
              <el-input
                v-model="queryItems.vendor"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.salesDate')"
              ><!--出售日-->
              <el-date-picker
                v-model="queryItems.reserveDate"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveStatus')"
              ><!--狀態-->
              <el-select
                v-model="queryItems.releaseOrderStatus"
                multiple
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option
                  v-for="item in base.releaseStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.oaCode')"
              ><!--OA CODE-->
              <el-input
                v-model="queryItems.OACode"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveArea')"
              ><!--抵達廠區-->
              <el-select
                :disabled="!enableAreaSelection"
                v-model="queryItems.area"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option v-for="item in base.areaBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.carPlat')"
              ><!--車輛號碼-->
              <el-input
                v-model="queryItems.carPlat"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--boxContain-->
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="sentApply" type="primary">{{
          $t("pages.button.search")
        }}</el-button
        ><!--查詢-->
        <el-button v-if="back" class="button-right" @click="cleanSearchVal" type="warning" style="margin-right: 10px">{{
          $t("pages.button.clean")
        }}</el-button
        ><!--清除-->
        <el-button class="blue-button button-right" @click="exportExcel" type="primary">{{
          $t("pages.button.exportExcel")
        }}</el-button
        ><!--下載Excel-->
      </div>
    </el-form>
    <h3>{{ $t("pages.wording.searchResult") }}</h3>
    <!--查詢結果-->
    <div class="boxContain c-table delta_table">
      <el-tabs v-model="activeName">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"><i class="el-icon-search"></i>{{ $t("pages.wording.searchResult") }}</span
          ><!--查詢結果-->
          <div class="s-table">
            <template>
              <el-table
                :data="releaseNewTableData"
                v-loading="loading"
                highlight-current-row
                @current-change="goReleasePage"
                border
                style="width: 100%"
                height="450px"
                @sort-change="tableChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div v-if="!readOnly">
                      <article v-if="scope.row.releaseOrderStatus === 'NEW'">
                        <article v-if="canEditReleaseForm">
                          <el-button type="text" size="medium">
                            <i class="el-icon-edit"></i>
                          </el-button>
                          <el-button @click="releaseDelete(scope.row)" type="text" size="medium"
                            ><i class="el-icon-delete"></i
                          ></el-button>
                        </article>
                        <el-button v-else type="text" size="medium"> <i class="el-icon-tickets"></i></el-button>
                      </article>
                      <article v-else-if="scope.row.releaseOrderStatus === 'sign'">
                        <el-button v-if="isApprovalRole" type="text" size="medium">
                          <i class="el-icon-edit"></i>
                        </el-button>
                        <article v-else-if="canEditReleaseForm">
                          <el-button type="text" size="medium">
                            <i class="el-icon-tickets"></i>
                          </el-button>
                          <el-button @click="releaseDelete(scope.row)" type="text" size="medium" />
                        </article>
                        <el-button v-else type="text" size="medium">
                          <i class="el-icon-tickets"></i>
                        </el-button>
                      </article>
                      <article v-else>
                        <el-button type="text" size="medium"> <i class="el-icon-tickets"></i></el-button>
                      </article>
                    </div>
                    <div v-else>
                      <el-button type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template> </el-table-column
                ><!--編輯-->
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="160">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="160"> </el-table-column
                ><!--預約單-->
                <el-table-column prop="carPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template> </el-table-column
                ><!--車牌-->
                <el-table-column prop="OACode" label="OACode" width="125"> </el-table-column
                ><!--OACode-->
                <el-table-column prop="reserveArea" :label="$t('pages.wording.area')" width="70"> </el-table-column
                ><!--廠區-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="reserveArriveDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.reserveArriveDatetime) }}
                  </template></el-table-column
                ><!--出售日期-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="90">
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="releaseOrderStatus" :label="$t('pages.wording.releaseOrderStatus')" width="160">
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
              </el-table>
            </template>
            <el-pagination
              :hide-on-single-page="true"
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.releaseTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.releaseTablePage.pageTotal"
              @current-change="changePageReleaseTable"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { role } from "@/config/role.js"
import { mapGetters } from "vuex"
export default {
  name: "PageSearchReleaseOrder",
  props: ["back"],
  data() {
    return {
      readOnly: false,
      activeName: "first",
      base: {
        releaseStatus: [
          {
            label: this.$t("release.status.NEW"),
            value: "NEW",
          },
          {
            label: this.$t("release.status.sign"),
            value: "sign",
          },
          {
            label: this.$t("release.status.in1"),
            value: "in1",
          },
          {
            label: this.$t("release.status.in2"),
            value: "in2",
          },
          {
            label: this.$t("release.status.finished"),
            value: "finished",
          },
          {
            label: this.$t("release.status.cancel"),
            value: "cancel",
          },
        ],
        areaBase: [],
      },
      queryItems: {
        region: "",
        area: "",
        reserveNo: "",
        releaseOrderNo: "",
        vendor: "",
        saleDate: [],
        releaseOrderStatus: [],
        reserveDate: [],
        reserveArriveTimeStart: "",
        reserveArriveTimeEnd: "",
        OACode: "",
        carPlat: "",
      },
      releaseTableData: [],
      releaseNewTableData: [],
      releaseExcel: [],
      pages: {
        pageCount: 5,
        pageSize: 20,
        releaseTablePage: {
          pageTotal: 1,
          pageCurrent: 1,
        },
      },
      queryParamsAfterSubmit: {
        area: "",
        reserveNo: "",
        releaseOrderNo: "",
        vendor: "",
        saleDate: [],
        releaseOrderStatus: [],
        reserveDate: [],
        OACode: "",
        carPlat: "",
      },
      defaultReleaseStatus: ["NEW", "sign", "in1", "in2", "finished", "cancel"],
      loading: false,
      enableAreaSelection: false,
      isApprovalRole: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles"]),
    /***************-GENERAL-***************/
    init() {
      let userRegion = this.getUserProfile().region
      let userArea = this.getUserProfile().area
      let userFactory = this.getUserProfile().factory
      let userRoles = this.getUserRoles()

      this.isApprovalRole = this.getUserProfile().isApprovalRole
      this.enableAreaSelection = this.getUserProfile().enableAreaSelection
      this.queryItems.area = utils.getFirstOrDefault(userArea)
      this.queryItems.region = utils.getFirstOrDefault(userRegion)
      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        this.readOnly = true
      }

      this.getArea(this.queryItems.region, userArea)
      this.getFactory(this.queryItems.region, this.queryItems.area, userFactory)

      //deal with query setting after go back action
      if (window.sessionStorage.getItem("queryParams") !== null) {
        let queryParams = JSON.parse(window.sessionStorage.getItem("queryParams"))
        this.queryItems.area = queryParams.area
        this.queryItems.reserveNo = queryParams.reserveNo
        this.queryItems.releaseOrderNo = queryParams.releaseOrderNo
        this.queryItems.vendor = queryParams.vendor
        this.queryItems.reserveDate = queryParams.reserveDate
        this.queryItems.releaseOrderStatus = queryParams.releaseOrderStatus
        this.queryItems.OACode = queryParams.OACode
        this.queryItems.carPlat = queryParams.carPlat
        window.sessionStorage.removeItem("queryParams")
        this.sentApply()
      }
    },
    cleanSearchVal() {
      //do nothing...
    },
    /***************-PAGING-***************/
    changePageReleaseTable(val) {
      this.releaseNewTableData = utils.buildPagingTable(this.releaseTableData, val, this.pages.pageSize)
    },
    tableChangeSort(cols) {
      utils.sortChangeMethod(cols, this.releaseTableData)
      this.releaseNewTableData = utils.buildPagingTable(
        this.releaseTableData,
        this.pages.preProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    /***************-FORM ACTIVE-***************/
    sentApply() {
      let userAD = this.getUserProfile().userAD
      let parameter = {
        reserveArea: this.queryItems.area,
        reserveNo: this.queryItems.reserveNo,
        releaseOrderNo: this.queryItems.releaseOrderNo,
        releaseOrderStatus:
          this.queryItems.releaseOrderStatus.length > 0
            ? this.queryItems.releaseOrderStatus
            : this.defaultReleaseStatus,
        vendor: this.queryItems.vendor,
        OACode: this.queryItems.OACode,
        CarPlat: this.queryItems.carPlat,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
      }

      if (this.queryItems.reserveDate != null && this.queryItems.reserveDate.length != 0) {
        parameter.reserveArriveDateTimeStart = utils.getISOString(this.queryItems.reserveDate[0] + " 00:00")
        parameter.reserveArriveDateTimeEnd = utils.getISOString(this.queryItems.reserveDate[1] + " 23:59")
      }
      //keep query parameters after submit query
      this.queryParamsAfterSubmit.area = this.queryItems.area
      this.queryParamsAfterSubmit.reserveNo = this.queryItems.reserveNo
      this.queryParamsAfterSubmit.releaseOrderNo = this.queryItems.releaseOrderNo
      this.queryParamsAfterSubmit.releaseOrderStatus = this.queryItems.releaseOrderStatus
      this.queryParamsAfterSubmit.vendor = this.queryItems.vendor
      this.queryParamsAfterSubmit.reserveDate = this.queryItems.reserveDate
      this.queryParamsAfterSubmit.OACode = this.queryItems.OACode
      this.queryParamsAfterSubmit.carPlat = this.queryItems.carPlat

      this.loading = true
      this.$store.dispatch("getReleaseTable", parameter)
    },
    releaseDelete(row) {
      let e = window.event
      e.stopPropagation()
      let vueInstance = this
      vueInstance
        .$confirm(vueInstance.$t("pages.button.confirmcancelrelease"))
        .then((_) => {
          utils.showLoading(vueInstance)
          let params = {
            reserveID: row.reserveRef,
            releaseID: row.id,
          }
          api
            .apiCancelReleaseData(params)
            .then((response) => {
              utils.closeLoading(vueInstance)
              if (response.data.success) {
                vueInstance.$message({
                  message: vueInstance.$t("message.alert.successCancel"),
                  type: "success",
                })
                vueInstance.sentApply()
              } else {
                utils.alertMessage(vueInstance, 1, response.data.messageCode)
              }
            })
            .catch(function (e) {
              utils.closeLoading(vueInstance)
              utils.alertMessage(vueInstance, 1, vueInstance.$t("message.alert.failCancel"))
            })
        })
        .catch((_) => {})
    },
    selectedArea(area) {
      let userFactory = this.getUserProfile().factory
      this.getFactory(this.queryItems.region, area, userFactory)
    },
    getArea(region, area) {
      this.$store.dispatch("getArea", { region: region, area: area })
    },
    getFactory(region, area, factory) {
      this.$store.dispatch("getFactory", {
        region: region,
        area: area,
        factory: factory,
      })
    },
    getExcelReleaseTable() {
      //當查詢結果為空時, DownloadExcel為Download所有資料
      let userAD = this.getUserProfile().userAD
      let parameter = {
        reserveArea: this.queryItems.area,
        reserveNo: this.queryItems.reserveNo,
        releaseOrderNo: this.queryItems.releaseOrderNo,
        vendor: this.queryItems.vendor,
        OACode: this.queryItems.OACode,
        CarPlat: this.queryItems.carPlat,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
        releaseOrderStatus:
          this.queryItems.releaseOrderStatus.length > 0
            ? this.queryItems.releaseOrderStatus
            : this.defaultReleaseStatus,
      }

      if (this.queryItems.reserveDate != null && this.queryItems.reserveDate.length != 0) {
        parameter.reserveArriveDateTimeStart = utils.getISOString(this.queryItems.reserveDate[0] + " 00:00")
        parameter.reserveArriveDateTimeEnd = utils.getISOString(this.queryItems.reserveDate[1] + " 23:59")
      }

      return new Promise((resolve) => {
        api.apiExportReleaseTable(parameter).then((response) => {
          resolve(response.data.result)
        })
      })
    },
    async exportExcel() {
      let vueInstance = this
      let header = new Array()
      header.push([
        vueInstance.$t("pages.wording.releaseOrder"),
        vueInstance.$t("pages.wording.reserveNo"),
        vueInstance.$t("pages.wording.carPlat"),
        vueInstance.$t("pages.wording.oaCode"),
        vueInstance.$t("pages.wording.area"),
        vueInstance.$t("pages.wording.vendor"),
        vueInstance.$t("pages.wording.salesDate"),
        vueInstance.$t("pages.wording.deltaContactName"),
        vueInstance.$t("pages.wording.applicatorName"),
        "SO",
        "SO LINE",
        vueInstance.$t("pages.wording.partNo"),
        vueInstance.$t("pages.wording.partName"),
        vueInstance.$t("pages.wording.netWeight"),
        vueInstance.$t("pages.wording.packType"),
        vueInstance.$t("pages.wording.packWeight"),
        vueInstance.$t("pages.wording.grossWeight"),
        vueInstance.$t("pages.wording.unit"),
        vueInstance.$t("pages.wording.status"),
        "Plant Code",
        "STORAGE.LOC",
      ])

      var excelReleaseTable
      this.releaseExcel = []

      excelReleaseTable = await this.getExcelReleaseTable()
      excelReleaseTable.forEach((item, index) => {
        var obj = {
          放行單: item.releaseOrderNo,
          預約單: item.reserveNo,
          車牌號碼: !item.tempCar ? item.carPlat : item.tmpCarPlat,
          "OA CODE": item.OACode,
          廠區: item.reserveArea,
          公司名稱: item.vendor,
          // "出售日期":item.saleDate,
          出售日期: utils.getFormateDateTime("Date", item.reserveArriveDate),
          台達聯絡人: item.deltaContactName,
          填單人: item.applicatorName,
          SO: item.SO,
          "SO LINE": item.SOLine,
          廢料料號: item.partNo,
          廢料名稱: item.partNameCN,
          淨重: String(parseFloat(item.netWeight).toFixed(this.$global.defaultPointNumForRelease)).replace(/\.0$/, ""),
          包裝種類: item.packType,
          總皮重: String(parseFloat(item.packWeight).toFixed(this.$global.defaultPointNumForRelease)).replace(
            /\.0$/,
            ""
          ),
          毛重: String(parseFloat(item.grossWeight).toFixed(this.$global.defaultPointNumForRelease)).replace(
            /\.0$/,
            ""
          ),
          數量單位: item.unit,
          狀態: this.$t("release.status." + item.releaseOrderStatus),
          "Plant Code": item.plantCode,
          "STORAGE.LOC": item.storageLogic,
        }
        this.releaseExcel.push(obj)
      })
      utils.exportExcelWithHeader(
        [header],
        [this.releaseExcel],
        ["data"],
        vueInstance.$t("pages.wording.ReleaseRoot") + " " + vueInstance.$t("pages.wording.searchResult")
      )
    },
    goReleasePage(data) {
      if (data.releaseOrderStatus === "NEW") {
        this.goEditReleasePage(data)
      } else if (data.releaseOrderStatus === "sign") {
        this.goApprovalReleasePage(data)
      } else {
        this.goEditReleasePage(data)
      }
    },
    goEditReleasePage(val) {
      //keep params of query for go back.
      let queryparams = {
        area: this.queryParamsAfterSubmit.area,
        reserveNo: this.queryParamsAfterSubmit.reserveNo,
        releaseOrderNo: this.queryParamsAfterSubmit.releaseOrderNo,
        vendor: this.queryParamsAfterSubmit.vendor,
        reserveDate: this.queryParamsAfterSubmit.reserveDate,
        releaseOrderStatus: this.queryParamsAfterSubmit.releaseOrderStatus,
        OACode: this.queryParamsAfterSubmit.OACode,
        carPlat: this.queryParamsAfterSubmit.carPlat,
      }
      let prevPageParams = {
        routeName: "PageSearchReleaseOrder",
        compName: "PageSearchReleaseOrder",
        key: {},
      }
      val["queryParams"] = queryparams
      val["prevPageParams"] = prevPageParams
      this.$router.push({
        name: "PageMyReleaseOrderForm",
        params: val,
      })
    },
    goApprovalReleasePage(data) {
      //keep params of query for go back.
      let queryparams = {
        area: this.queryParamsAfterSubmit.area,
        reserveNo: this.queryParamsAfterSubmit.reserveNo,
        releaseOrderNo: this.queryParamsAfterSubmit.releaseOrderNo,
        vendor: this.queryParamsAfterSubmit.vendor,
        reserveDate: this.queryParamsAfterSubmit.reserveDate,
        releaseOrderStatus: this.queryParamsAfterSubmit.releaseOrderStatus,
        OACode: this.queryParamsAfterSubmit.OACode,
        carPlat: this.queryParamsAfterSubmit.carPlat,
      }
      let prevPageParams = {
        routeName: "PageSearchReleaseOrder",
        key: {},
      }
      window.sessionStorage.setItem("tempQueryParams", JSON.stringify(queryparams))
      window.sessionStorage.setItem("prevPageParams", JSON.stringify(prevPageParams))

      this.$router.push({
        name: "PageMyApprovalReleaseForm",
        params: { releaseID: data.id },
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  computed: {
    canEditReleaseForm() {
      //判斷有無可編修放行單權限
      //先用是否有我的放行單功能作為依據
      return this.getUserProfile().systemFunctions.includes("PageMyReleaseOrder")
    },
  },
  watch: {
    "$store.getters.storeCallback": function (val) {
      val.fn()
    },
    "$store.getters.releaseTable": function (datas) {
      if (datas.length <= 0) {
        this.releaseTableData = []
        this.releaseNewTableData = []
      } else {
        this.releaseTableData = datas
        this.pages.releaseTablePage.pageTotal = this.releaseTableData.length
        this.releaseNewTableData = utils.buildPagingTable(
          this.releaseTableData,
          this.pages.releaseTablePage.pageCurrent,
          this.pages.pageSize
        )
      }
      this.loading = false
    },
    "$store.getters.areaBase": function (val) {
      this.base.areaBase = val
    },
    "$store.getters.factoryBase": function (val) {
      this.base.factoryBase = val
    },
  },
}
</script>

<style>
.pageSearchReleaseOrder .button-right {
  margin-right: 10px;
}
</style>
